//PRUEBAS
const Env = {
  UrlSeguridad: 'https://backapp.electrohuila.com.co:8071/ehrest/index.php/EHFact2',
  UrlBackendEHGC: 'https://backapp.electrohuila.com.co:8071/ehrest/index.php/EHGC',

  UrlBackendCuentaNueva: 'https://qa-enlinea.electrohuila.com.co:8002/public/api',
  UrlPublicFilesCuentaNueva: 'https://qa-enlinea.electrohuila.com.co:8002/public/',

  UrlBackend: 'https://qa-enlinea.electrohuila.com.co:8008/public/api',
  UrlFiles: 'https://qa-enlinea.electrohuila.com.co:8008/',
  UrlFilesPublic: 'https://qa-enlinea.electrohuila.com.co:8008/public/',

  urlDIAN: 'https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=',

  ApplicationName: 'ElectroHuila en linea',
  ApplicationCode: 'EHLINEA',
  DirectoryName: 'home/#',
  Company: 'Electrohuila S.A. - E.S.P.',
  TypeClain: 'WE',
  AllowedSize: 5, // Valor indicado en Megas
  AllowedNumberFiles: 5,
  mayorDateFiles: 30,
  mayorDateFiles2: 60,
  nomTipoJuridico: 'DATOS DE LA SOCIEDAD',
  nomEscrituraJuridico: 'Número de escritura de constitución',
  nomPersonaJuridico: 'Razón Social',
  nomRepreLegalJuridico: 'Nombre del representante legal',
  nomTipoNatural: 'DATOS DEL ESTABLECIMIENTO DE COMERCIO',
  nomEscrituraNatural: 'Número de la matrícula mercantil',
  nomPersonaNatural: 'Nombre Completo',
  nomEstableComercioNatural: 'Nombre del establecimiento del comercio',
  AllowedExtensionFiles: ['pdf', 'jpg', 'png', 'gif'], // Extensiones permitidas
  UrlAppAndroid: 'https://play.google.com/store/apps/details?id=co.com.solidcloud.ehautogen&hl=es_419',
  UrlAppIos: 'https://apps.apple.com/co/app/electrohuila/id1492379467',
  ValidCycles: ['1'], // Solo esos ciclos pueden ver opcion de grandes clientes
  tipoUsuario: { propietario: 'propietario', electricista: 'electricista' },
  version: '1.0.4',
  app_new_account: 'https://qa-enlinea.electrohuila.com.co/cuentas-nueva-radicacion-app/', //'http://localhost:5173/', //
};

export default Env;
